import { EventStatusType } from '@remodeling/content';
import { NameValueType } from './../types/common';

export const EVENT_TAB: NameValueType<EventStatusType>[] = [
  {
    name: '진행중',
    value: 'ING',
  },
  {
    name: '당첨자 안내',
    value: 'WIN',
  },
  {
    name: '종료',
    value: 'END',
  },
];
